module.exports = __webpack_public_path__ + "img/benefit_leaders-pre-game-tailgate.2a4b7651.jpg";